// Version configuration for EchoKit
export const VERSION = '1.0.1';
export const APP_NAME = 'EchoKit';
export const VERSION_DISPLAY = `${APP_NAME} version ${VERSION}`;
